module.exports = __webpack_public_path__ + "static/media/cammino_santiago_1.bed1c025.jpg";